import { MarketCalculusCard } from '../../../components/preview/Preview'
import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSDSsearchParams } from '../../../store/searchDataStore'
import MarketOverviewWorldTable from './MarketOverviewTable/MarketOverviewWorldTable'
import McPageHelpers from '../McPageHelpers'
import MCTitleCard from '../../../components/title-card/MCTitleCard'
import MultiValueLineAndBarChart from '../../../components/amcharts/MultiValueLineAndBarChart'
import { MARKET_CHANGE_CHART_TYPES } from '../../../utils/AMChartsSettings'
import { Col, Row } from 'reactstrap'

const ChangeCard = forwardRef((props, ref) => {
  const {
    code,
    title,
    subTitle,
    data,
    timeTags,
    type,
    isYearTable,
    isPercentage,
    id,
    graphicCode
  } = props
  const { t } = useTranslation()
  const searchParams = useSDSsearchParams()

  const formattedData = McPageHelpers.generateMarketOverviewWorldTableChangeData(data, isPercentage)

  return (<MarketCalculusCard className="my-3">
    <Row>
      <Col md="6">
        <MCTitleCard chartTitle={title} code={code} codeColor="info" textColor={'#09c2de'}
                     chartSubTitle={subTitle ?? (t('world') + ' ' + searchParams.hsCode ?? '')}/>
        <MarketOverviewWorldTable data={formattedData} type={type}
                                  isYearTable={isYearTable}
                                  isPercentage={isPercentage}
                                  timeTags={timeTags}
                                  title={code + ' ' + title}
                                  ref={ref}/>
      </Col>
      <Col md="6">
        <div id={id + McPageHelpers.FOR_PDF_ID}>
          <MCTitleCard chartTitle={title} code={graphicCode} codeColor="light" textColor={'#09c2de'}
                       chartSubTitle={subTitle ?? (t('world') + ' ' + searchParams.hsCode ?? '')}/>

          <MultiValueLineAndBarChart
            chartId={id + graphicCode}
            yFormatterType={MARKET_CHANGE_CHART_TYPES.QUANTITY}
            chartData={McPageHelpers.formatChangeBarData(data) ?? []}
            yTitle={t('value_with_dollar_t')}
            yTitleSecond={t('value_with_percent')}
          />
        </div>
      </Col>
    </Row>
  </MarketCalculusCard>)
})

export default ChangeCard
